import React from 'react'
import { Container, Box } from './styles'
import { Text } from '~/themes/styles'

/**
 * @typedef {object} IProps
 * @property {{ label: string, color: string }} status
 */

/** @type {React.FC<IProps>} */
export const StatusBox = ({ status }) => {
  return (
    <>
      {status && status.label && status.color && (
        <Container>
          <Box color={status.color}>
            <Text size="12px" color={status.fontColor} bold>
              {status.label}
            </Text>
          </Box>
        </Container>
      )}
    </>
  )
}
